<template>
    <p-search-screen
        title="Web Catalogs"
        api-destination="catalogs"
        search-destination="searchcatalogs"
        edit-key="catalogId"
        :edit-url-func="item => `/webcatalogs/${item.catalogId}`"
        add-url="/webcatalogs/new"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        :use-is-active-checkbox="false"
        add-new-button
    >
        <template v-slot:belowSearch>
            <p-form>
                <b-row class="mt-4 me-2">
                        <b-col>
                        <p-checkbox label="Open"
                                    v-model="filters.active" />
                        <p-checkbox label="Closed"
                                    class="ms-2"
                                    v-model="filters.closed" />
                        <p-checkbox label="Hold"
                                    class="ms-2"
                                    v-model="filters.hold" />
                        <p-checkbox label="Inactive"
                                    class="ms-3"
                                    v-model="filters.inactive" />
                        </b-col>
                    </b-row>
            </p-form>
        </template>
    </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'CatalogsFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                sortDesc: false,
                searchBy: 'name',
                active: true,
                closed: true,
                hold: true,
                inactive: false
            },
            filterBy: ['All', 'Catalog Name', 'Catalog Group', 'Barcode'],
            fields: [
                {
                    key: 'name',
                    label: 'Catalog Name',
                    sortable: true
                },
                {
                    key: 'group',
                    label: 'Catalog Group(s)'
                },
                {
                    key: 'status',
                    label: 'Catalog Status',
                    sortable: true
                }
            ]
        };
    }
};
</script>
<style scoped></style>
